/*********************** Custom JS for Boost AI Search & Discovery  ************************/

const customize = {
  updateProductItem: (componentRegistry) => {
    componentRegistry.useComponentPlugin('ProductItem', {
      name: 'update price visibility based on collection metafield',
      enabled: true,
      apply: () => ({
        afterRender(element) {
          let productData = element.getParams().props.product;
          let productItem = document.querySelector('.boost-sd__product-item[data-product-id="' + productData.id + '"]');

          if (productData && productItem) {
            const collectionMetafield = boostSDData.showPrice;
            let shouldShowPrice = false;
            if (collectionMetafield?.length > 0 && collectionMetafield[0] == "Show price") {
               shouldShowPrice = true;
            }

            // Find the price element within the product item
            const priceElement = productItem.querySelector('.boost-sd__product-price');
            if (priceElement) {
              priceElement.style.display = shouldShowPrice ? 'block' : 'none';
            }
          }
        }
      }),
    });
  }
}

window.__BoostCustomization__ = (window.__BoostCustomization__ ?? []).concat([customize.updateProductItem]);

